var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { resolve, select } from '@cvent/nucleus-dynamic-css';
import NucleusButton from 'nucleus-core/buttons/Button';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
* The basic button widget UI implementation.
*/
var Button = function (props) {
    // Originally, buttons were implemented with rich text editors, but since then
    // they have been updated to be normal textboxes. So we have to allow the text
    // property to come in as rich text or normal plain text. https://jira/browse/FLEX-6581
    var textElement;
    if (props.isRichText) {
        textElement = React.createElement("span", __assign({}, resolve(props, 'text'), { dangerouslySetInnerHTML: {
                __html: props.text
            } }));
    }
    else {
        textElement = React.createElement("span", __assign({}, resolve(props, 'text')), props.text);
    }
    return React.createElement("div", __assign({}, resolveTestId(props), resolve(props, 'container')),
        React.createElement("div", __assign({}, resolve(props, 'buttonWrapper')),
            React.createElement(NucleusButton, __assign({}, select(props, 'button'), { onClick: props.onClick, kind: props.kind, disabled: props.disabled }), textElement)),
        props.link && props.link.enabled && React.createElement("div", __assign({}, resolve(props, 'linkWrapper')),
            React.createElement("a", __assign({}, resolve(props, 'link', 'inlineBlock'), { href: "#", onClick: props.link.onClick }), props.link.text)));
};
Button.displayName = 'Button';
Button.propTypes = {
    text: PropTypes.string,
    onClick: PropTypes.func,
    kind: PropTypes.string,
    link: PropTypes.shape({
        text: PropTypes.string.isRequired,
        onClick: PropTypes.func,
        enabled: PropTypes.bool.isRequired
    }),
    disabled: PropTypes.bool,
    isRichText: PropTypes.bool
};
export default Button;
